import { ReactNode, useRef, useState } from 'react';
import useOnClickOutside from 'use-onclickoutside';
// import { FaCheck } from 'react-icons/fa';

interface Options {
  key: string;
  value: string;
  selected?: boolean;
  destructive?: boolean;
}

export default ({
  title,
  icon = undefined,
  options,
  onSelect,
}: {
  title?: string;
  icon?: ReactNode;
  options: Options[];
  onSelect: (option: any) => void;
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const close = () => setOpen(false);
  useOnClickOutside(ref, close);

  const handleToggleOpen = () => {
    setOpen(!open);
  };

  const handleSelect = e => {
    setOpen(false);
    onSelect(e.currentTarget.dataset.option);
  };
  return (
    <div ref={ref} className="relative inline-block text-left">
      <div>
        <span>
          <button
            type="button"
            className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 active:bg-gray-50 active:text-gray-800"
            id="options-menu"
            aria-haspopup="true"
            aria-expanded="true"
            onClick={handleToggleOpen}
          >
            {title}
            {icon ? (
              icon
            ) : (
              <svg className="w-5 h-5 ml-2 -mr-1" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>
        </span>
      </div>

      {open && (
        <div className="absolute right-0 z-40 w-56 mt-2 origin-top-right rounded-md shadow-lg">
          <div className="bg-white rounded-md shadow-xs">
            <div
              className="py-1"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {options.map((option, i) => (
                <div
                  key={`option-${i}`}
                  className={`flex items-center justify-between px-4 py-2 text-sm leading-5 cursor-pointer hover:bg-gray-100 ${
                    option.destructive
                      ? 'text-red-700  hover:text-red-800  focus:text-red-800'
                      : 'text-gray-700  hover:text-gray-900  focus:text-gray-900'
                  } focus:outline-none focus:bg-gray-100`}
                  role="menuitem"
                  data-option={option.key}
                  onClick={handleSelect}
                >
                  {option.value}
                  {option.selected && (
                    <svg
                      className="inline-block w-3 h-3 ml-2 -mt-1"
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 512 512"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                    </svg>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
